import { PageContainer } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { Box, Grid, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ForbiddenError } from "../../../../errors/ForbiddenError";
import { useAuth } from "../../../../hooks/useAuth";
import { AlertCard } from "../-internal_components/cards/AlertCard";
import { DecisionCards } from "../-internal_components/cards/DecisionCard";
import { DetailsCard } from "../-internal_components/cards/DetailsCard";
import { StatusCard } from "../-internal_components/cards/StatusCard";
import { requestAnticipationEvaluationQuotationsDetailQueryOptions } from "../-queries";

const DetailsPage: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const { requestAnticipationEvaluationQuotationId } = Route.useParams();

  const { data: requestAnticipationEvaluationQuotation, isLoading } = useQuery(
    requestAnticipationEvaluationQuotationsDetailQueryOptions(
      requestAnticipationEvaluationQuotationId,
    ),
  );

  // const [data, setData] =
  //   useState<RequestAnticipationEvaluationQuotation | null>(null);
  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   async function fetchDetails(): Promise<void> {
  //     try {
  //       const resp =
  //         await getRequestAnticipationEvaluationQuotation(requestAnticipation);
  //       setData(resp);
  //     } catch (err) {
  //       console.error(err);
  //       enqueueSnackbar(
  //         t("requestAnticipationEvaluationQuotations.detailFetchError"),
  //         {
  //           variant: "error",
  //         },
  //       );
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  //   fetchDetails();
  // }, [requestAnticipation, t]);

  if (isLoading) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>{t("loading")}</Typography>
      </Box>
    );
  }

  if (!requestAnticipationEvaluationQuotation) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>{t("noData")}</Typography>
      </Box>
    );
  }

  return (
    <PageContainer
      showBackButton
      title={requestAnticipationEvaluationQuotation.quotation.reference_number}
    >
      <AlertCard
        isPendingAlertVisible={
          user?.roles_names.includes(
            "Request Anticipation Evaluation Quotation - Update",
          ) || false
        }
        status={requestAnticipationEvaluationQuotation.status}
      />
      <Grid
        container
        spacing={3}
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 3,
          width: "100%",
        }}
      >
        <Grid
          size={8}
          sx={{ display: "flex", flexDirection: "column", gap: 3 }}
        >
          <DetailsCard
            requestAnticipationEvaluationQuotation={
              requestAnticipationEvaluationQuotation
            }
          />

          <DecisionCards
            isDecisionButtonVisible={
              !!user?.roles_names.includes(
                "Request Anticipation Evaluation Quotation - Update",
              )
            }
            requestAnticipationEvaluationQuotation={
              requestAnticipationEvaluationQuotation
            }
          />
        </Grid>
        <Grid
          size={4}
          sx={{ display: "flex", flexDirection: "column", gap: 3 }}
        >
          <StatusCard
            requestAnticipationEvaluationQuotation={
              requestAnticipationEvaluationQuotation
            }
          />
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export const Route = createFileRoute(
  "/_private/request_anticipation_evaluation_quotations/$requestAnticipationEvaluationQuotationId/",
)({
  beforeLoad: ({ context }) => {
    if (
      !context.auth.user?.roles_names.includes(
        "Request Anticipation Evaluation Quotation - View",
      )
    ) {
      throw new ForbiddenError();
    }
  },
  component: DetailsPage,
});
